var map = {
	"./apk.png": "f041",
	"./audio.png": "87de",
	"./excel.png": "c906",
	"./html.png": "cf42",
	"./pdf.png": "32fe",
	"./picture.png": "1a05",
	"./ppt.png": "ca6d",
	"./psd.png": "a33c",
	"./txt.png": "85dd",
	"./unknown.png": "39d4",
	"./video.png": "7ac4",
	"./word.png": "4d71",
	"./zip.png": "96c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1284";